import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from '../../components/Layout'
import AdminHome from './AdminHome'
import AdminUsers from './AdminUsers'
import AdminSessions from './AdminSessions'
import AdminApplications from './AdminApplications'
import AdminContent from './AdminContent'
import AdminReports from './AdminReports'
import AdminSecurity from './AdminSecurity'
import AdminSettings from './AdminSettings'

export default function AdminDashboard() {
  return (
    <Layout role="admin">
      <Routes>
        <Route index element={<Navigate to="home" replace />} />
        <Route path="home" element={<AdminHome />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="sessions" element={<AdminSessions />} />
        <Route path="applications" element={<AdminApplications />} />
        <Route path="content" element={<AdminContent />} />
        <Route path="reports" element={<AdminReports />} />
        <Route path="security" element={<AdminSecurity />} />
        <Route path="settings" element={<AdminSettings />} />
      </Routes>
    </Layout>
  )
}
